import { render, staticRenderFns } from "./vs-tab.vue?vue&type=template&id=594a8d72"
import script from "./vs-tab.vue?vue&type=script&lang=js"
export * from "./vs-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports